
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configuration
const firebaseConfig = {
  apiKey: "AIzaSyB6qzT_8SuXJqD5jl5dUcqdzCSy1f4JiJM",
  authDomain: "idea-shelf-e3c9b.firebaseapp.com",
  projectId: "idea-shelf-e3c9b",
  storageBucket: "idea-shelf-e3c9b.firebasestorage.app",
  messagingSenderId: "1079106665372",
  appId: "1:1079106665372:web:c7443e9d4e5c93741ca659",
  measurementId: "G-5RQG2389KP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Firestore (Uses default memory persistence to avoid lock errors in dev/iframe)
// To enable offline persistence later, we can add a robust try/catch block here
export const db = getFirestore(app);

export const storage = getStorage(app);

export default app;
